import React from "react";
import { Field, makeStyles, Select } from "@fluentui/react-components";
import { useGlobalStyles } from "../../../utils/Theming";

const useStyles = makeStyles({
  select: {
    maxWidth: "100%",
    overflow: "hidden",
  },
});

const SelectField = ({ name, label, value, options = [], error, onChange }) => {
  const styles = useStyles();
  const globalStyles = useGlobalStyles();

  const renderOptions = () => {
    const defaultOption = value ? null : (
      <option key="default" value="">
        Nothing selected
      </option>
    );

    const optionElements = Array.isArray(options)
      ? options.map((option) => (
          <option key={option.key} value={option.key} className={globalStyles.truncateText}>
            {String(option.value)}
          </option>
        ))
      : Object.entries(options).map(([key, value]) => (
          <option key={key} value={key} className={globalStyles.truncateText}>
            {String(value)}
          </option>
        ));

    return defaultOption ? [defaultOption, ...optionElements] : optionElements;
  };

  return (
    <Field label={label} validationState={error ? "error" : "none"} validationMessage={error}>
      <Select value={value} onChange={(e) => onChange(name, e.target.value)} className={styles.select}>
        {renderOptions()}
      </Select>
    </Field>
  );
};

export default SelectField;
